<template>
  <div class="BasicLayout-footer">
    <div class="reference">
      <span style="display: inline-flex; align-items: center; vertical-align: middle;">
        <span style="white-space: nowrap;">{{ t('footer.span3') }}：</span>
<!--        <span>-->
        <el-radio-group style="display: flex; align-items: center; margin-left: 5px;" text-color="#3870ff" fill="#3870ff" v-model="lang" @change="changeLanguage">
          <el-radio value="zh" size="small">中文(Chinese)</el-radio>
          <el-radio value="en" size="small">英文(English)</el-radio>
        </el-radio-group>
<!--        </span>-->
        <span style="margin-left: 15px;margin-right: 15px;cursor: pointer;" @click="store.isAboutUs(true)">{{t('header.span6')}}</span>
        <span style="margin-right: 15px;">{{t('footer.span1')}}</span>
        <a href="https://beian.miit.gov.cn" style="width: unset; color:#5D5F66;margin-right: 10px;" target="_blank" aria-label="Visit MIIT Registration Page">{{t('footer.span2')}}</a>
        <!--      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=xxxxx" style="width: unset; color:#5D5F66;" target="_blank">吉公网安备xxxxxx号</a>-->
      </span>
    </div>
    <p class="reference">
      <span style="margin-right: 1vw;">
        <span style="font-size:15px;margin-right: 15px;">{{t('footer.span4')}}:</span>
        <span style="font-size:13px;margin-right: 15px;">
          <a href="https://www.ielts.org" target="_blank">{{t('footer.span5')}}</a>
        </span>
        <span style="font-size:13px;margin-right: 15px;">
          <a href="https://www.cambridgeenglish.org/exams-and-tests/ielts/" target="_blank">{{t('footer.span6')}}</a>
        </span>
        <span style="font-size:13px;margin-right: 15px;">
          <a href="https://www.thesaurus.com" target="_blank">{{t('footer.span7')}}</a> </span>
        <span style="font-size:13px;margin-right: 15px;">
          <a href="https://www.ielts.org/for-test-takers/how-ielts-is-scored" target="_blank">{{t('footer.span8')}}</a>
        </span>
        <span style="font-size:13px;margin-right: 15px;">
          <a href="https://takeielts.britishcouncil.org/take-ielts/prepare/free-ielts-practice-tests/writing-practice-test-1-academic" target="_blank">{{t('footer.span8')}}</a>
        </span>
      </span>
    </p>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { useAppStore } from "@/store/index";
import i18n from '../../locale/i18n';
import { getInitialLanguage,setLanguage } from '../../utils/language';

const t = (key) => i18n.global.t(key);
const store = useAppStore();

const lang = ref(getInitialLanguage());
const router = useRouter();
const route = useRoute();

const changeLanguage = (lang) => {
  i18n.locale = lang;
  setLanguage(lang)
  //router.replace({ name: route.name, params: { lang:lang } });
  window.location.href = `/${lang}/home.html`;
}

</script>

<style lang="less" scoped>
.BasicLayout-footer {
  background-color: #061122;
  color: #fff;
  padding: 1vw;
  .reference {
    text-align: center;
    color: #5D5F66;
  }
  a, a:focus, a:hover {
    text-decoration: none !important;
    outline: none !important;
  }
}
</style>
